/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const PaymentType = {
    ACCOUNT_PLAN: 'AccountPlan'
} as const;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];

